import { useTranslation } from "react-i18next";
import { useDecision } from "@optimizely/react-sdk";
import PhotoTransformationsModal from "../modals/PhotoTransformationsModal";
import TransformationsModelModal from "../modals/TransformationsModelModal";
import { RowInfo, FormAutocomplete } from "../../common";
import { Textarea } from "../../common/Textarea";
import NubImageUpload from "../../common/NubImageUpload";
import NubImageUploadModal from "../modals/NubImageUploadModal";
import { useState } from "react";
import { subtypeFromPrompt } from "../transformationPrompt";

const Photo = ({ useQuery, showTransformations = false }) => {
    const { t } = useTranslation();
    const [decisionPhotoTransformations] = useDecision('photo_transformations');
    const [collection, setCollection] = useQuery();
    const [localPrompt, setLocalPrompt] = useState(collection.prompt);

    const setPrompt = (value) => {
        const prompt = (value || '').trim();
        setCollection({
            prompt,
            task_subtype: subtypeFromPrompt(prompt),
        });

        // Keep short in-progress text in the field even if it is not persisted yet.
        if (value?.length > 0) {
            setLocalPrompt(value);
        }
    };

    const handleChange = (value) => {
        setLocalPrompt(value);
    };

    return (
        <>
            <p dangerouslySetInnerHTML={{ __html: t('Require the player to submit an image.') }} />
            {
                showTransformations
                    ? (
                        <>
                            {
                                decisionPhotoTransformations?.enabled
                                    ? (
                                        <RowInfo help={<NubImageUploadModal />} isFull>
                                            <NubImageUpload
                                                label={t("Add Reference Images")}
                                                name="transformations_media"
                                                useQuery={useQuery}
                                                maxImages={9}
                                            />
                                        </RowInfo>
                                    )
                                    : null
                            }
                            <RowInfo help={<PhotoTransformationsModal />}>
                                <Textarea
                                    label={t("Transformation Instructions")}
                                    name="prompt"
                                    rows={5}
                                    mode="clean"
                                    defaultValue={localPrompt}
                                    setValue={setPrompt}
                                    onChange={handleChange}
                                    className="form-control reset-form-control"
                                    stripHtml={true}
                                    required
                                    placeholder={t("Example: Change the photo so that all characters appear as lego characters.")}
                                />
                            </RowInfo>
                            {
                                decisionPhotoTransformations?.enabled
                                    ? (
                                        <RowInfo help={<TransformationsModelModal />}>
                                            <FormAutocomplete
                                                label={t("Transformations Model")}
                                                name="transformations_model"
                                                useQuery={useQuery}
                                                options={[
                                                    { id: "0", name: t('OpenAI') },
                                                    { id: "1", name: t('Google Gemini') },
                                                    { id: "2", name: t('Google Gemini Pro 3') },
                                                ]}
                                                size="small"
                                                mode="clean"
                                            />
                                        </RowInfo>
                                    )
                                    : null
                            }
                        </>
                    )
                    : null
            }
        </>
    );
};

export default Photo;
